const MembershipsIndex = () => import('@/views/Dashboard/Membership/MembershipsIndex');
const MembershipsAll = () => import('@/views/Dashboard/Membership/MembershipAll/MembershipsAll');
const MembershipsShowItem = () => import('@/views/Dashboard/Membership/MembershipShowItem');
const MembershipsCreate = () => import('@/views/Dashboard/Membership/MembershipsCreate');
const MembershipsEdit = () => import('@/views/Dashboard/Membership/MembershipsEdit');

export default {
  path: '/memberships',
  component: MembershipsIndex,
  children: [
    {
      path: '/',
      name: 'memberships',
      component: MembershipsAll,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'membershipDivisionFilter',
          'membershipStatusFilter',
          'membershipFromDateFilter',
          'membershipToDateFilter',
          'membershipCertificateStatusFilter',
        ],
      },
    },
    {
      path: 'preselected/:memberPreSelectedId',
      name: 'membershipsPreSelected',
      component: MembershipsAll,
    },
    {
      path: 'preselected-membership-type/:membershipTypePreSelectedId',
      name: 'membership-types-memberships',
      component: MembershipsAll,
    },
    {
      path: 'show/:id',
      name: 'memberships-show',
      component: MembershipsShowItem,
      meta: { preservePageStateFor: 'memberships' },
    },
    {
      path: 'show/:id/preselected/:memberPreSelectedId',
      name: 'memberships-showPreSelected',
      component: MembershipsShowItem,
    },
    {
      path: 'create',
      name: 'memberships-create',
      component: MembershipsCreate,
      meta: { preservePageStateFor: 'memberships' },
    },
    {
      path: 'create/:memberPreSelectedId',
      name: 'memberships-create-preselected',
      component: MembershipsCreate,
    },
    {
      path: 'create/preselected/:memberPreSelectedId',
      name: 'memberships-createPreSelected',
      component: MembershipsCreate,
    },
    {
      path: 'edit/:id',
      name: 'memberships-edit',
      component: MembershipsEdit,
      meta: { preservePageStateFor: 'memberships' },
    },
    {
      path: 'edit/:id/preselected/:memberPreSelectedId',
      name: 'memberships-editPreSelected',
      component: MembershipsEdit,
    },
  ],
};
